var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 406,
    height: 386,
    viewBox: "-65 9 406 386",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Man / Head / 6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M315.499 178.151C315.499 206.823 297.063 230.066 274.321 230.066C251.581 230.066 233.145 206.823 233.145 178.151C233.145 149.479 251.581 126.237 274.321 126.237C297.063 126.237 315.499 149.479 315.499 178.151Z",
    fill: "#19141E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Face color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Face",
    d: "M218.057 383.811L216.334 324.185C216.334 324.185 288.628 329.954 304.094 321.902C304.094 321.902 322.996 224.298 300.452 170.248L299.996 168.143L147.433 150.258L138.88 238C133.741 222.808 91.3272 205.581 80.2409 227.336C56.2145 274.476 142.122 306.217 142.122 306.217L133.398 384.527",
    fill: "#E576C6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill 5",
    opacity: 0.398926,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.334 324.184L167.584 313.708L216.1 346.554L216.334 324.184Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.304 236.885L272.149 278.162L251.96 278.419L255.304 236.885Z",
    fill: "#405FD3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.34 238.474C238.343 244.033 234.659 249.353 229.115 250.358C223.568 251.364 218.258 247.672 217.256 242.115C216.252 236.556 219.935 231.236 225.481 230.23C231.028 229.225 236.336 232.915 237.34 238.474Z",
    fill: "#0D0B6D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.947 238.474C294.951 244.033 291.267 249.353 285.722 250.358C280.176 251.364 274.866 247.672 273.864 242.115C272.86 236.556 276.542 231.236 282.089 230.23C287.636 229.225 292.944 232.915 293.947 238.474Z",
    fill: "#0D0B6D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Hair",
    d: "M150.209 252.976C135.744 228.164 114.815 220.597 105.421 218.378C101.675 207.524 98.8183 194.937 96.8115 181.55C91.4296 145.721 117.422 113.032 138.417 103.646C159.669 94.1464 196.313 80.9825 249.95 98.8515C286.011 110.873 309.06 82.0921 330.28 94.3842C366.54 115.395 332.813 207.38 240.87 184.012C175.102 167.296 173.412 171.49 172.848 183.64C171.025 222.915 164.914 246.02 150.209 252.976Z",
    fill: "#2F2F3D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 18",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.259 279.954C227.259 279.954 233.741 291.757 247.75 291.478L227.259 279.954Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 20",
    d: "M227.259 279.954C227.259 279.954 233.741 291.757 247.75 291.478",
    stroke: "#252535",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 22",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.412 238.968C250.412 251.89 239.958 262.365 227.063 262.365C214.17 262.365 203.716 251.89 203.716 238.968C203.716 226.046 214.17 215.569 227.063 215.569C239.958 215.569 250.412 226.046 250.412 238.968Z",
    stroke: "#252535",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 24",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.2 238.968C309.2 251.89 298.746 262.365 285.853 262.365C272.958 262.365 262.504 251.89 262.504 238.968C262.504 226.046 272.958 215.569 285.853 215.569C298.746 215.569 309.2 226.046 309.2 238.968Z",
    stroke: "#252535",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 26",
    d: "M260.603 240.052H250.508",
    stroke: "#252535",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 28",
    d: "M203.716 238.968H146.041",
    stroke: "#252535",
    strokeWidth: 4
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.edad7ae5.svg";
export { ForwardRef as ReactComponent };